import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useDispatch, useSelector } from 'react-redux';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';
import { useSaleMode } from '../../../context';
import { PaymentOptions } from './PaymentOptions';
import { PaymentOptionCard } from './PaymentOptionCard';
import { MenuCardsProps, SaleType } from '../../../types';
import { OptionSummaryDetails } from '../OptionSummaryDetails';
import { deskingActions, deskingSelectors } from '../../../model';

export const FinancePaymentOption = ({ isCalculating, financePricing }: MenuCardsProps) => {
  const { saleType } = useSaleMode();

  const classes = useStyles();

  const dispatch = useDispatch();

  const selectedTerm = useSelector(deskingSelectors.getSelectedFinanceOptionTerm);
  const selectedFinanceOption = useSelector(deskingSelectors.getSelectedFinanceOption);

  const handleSelectOption = (term: string) => {
    dispatch(deskingActions.selectFinanceOption({ term }));
  };

  const renderBySaleType: Record<SaleType, ReactNode> = {
    [SaleType.Cash]: null,
    [SaleType.Financing]: (
      <>
        <Box className="financingCards">
          {Object.entries(financePricing).map(([term, price]) => (
            <PaymentOptionCard
              paymentOption={price}
              isCalculating={isCalculating}
              isSelected={selectedTerm === term}
              onSelectOption={() => {
                handleSelectOption(term);
              }}
            />
          ))}
        </Box>

        <RenderWithCondition condition={!!selectedFinanceOption}>
          <PaymentOptions payment={selectedFinanceOption!} saleType={saleType} />
        </RenderWithCondition>

        <OptionSummaryDetails />
      </>
    ),
  };

  return <Box className={classes.container}>{renderBySaleType[saleType]}</Box>;
};

const useStyles = makeStyles({
  container: {
    gap: '12px',
    display: 'flex',
    flexDirection: 'column',

    '& .financingCards': {
      gap: '0.5rem',
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(12rem, 1fr))',
    },
  },
});
